import { useEffect, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ACTIONS from '../../../redux/action';
import Navigation from '../components/navigation/navigation';
import i18n from '../../../utils/i18n';
import { withTranslation } from 'react-i18next';
import CheckboxInput from '../components/searchInputs/newCheckboxInput';
import { zipInput, preferencesText } from '../data/searchFlowText';
import { TextField } from '@mui/material';
import LoadingIndicator from '../../../shared/LoadingIndicator/loadingIndicator';
import { cities } from '../data/cities';

const Preferences = ({ ...props }) => {
	const companyStore = useSelector((state) => state.company_store);
	const matchScoreWeights = useSelector((state) => state.match_score_weights);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);
	const [searchValue, setSearchValue] = useState('');

	const dispatch = useDispatch();

	const handleNext = useCallback(
		async (inc) => {
			setLoading(true);
			await props.fetchCherryPotentialProviders(
				companyStore,
				matchScoreWeights
			);
			props.handleNext();
		},

		[props, companyStore.zip_code]
	);

	const handleBack = useCallback(
		(decr) => {
			props.handleBack(decr);
		},
		[props]
	);

	useEffect(() => {
		function handleKeyDown(e) {
			if (e.keyCode === 13) {
				handleNext();
			}
		}
		document.addEventListener('keydown', handleKeyDown);
		return function cleanup() {
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [props, handleNext]);

	const handleChange = async (event) => {
		dispatch(
			ACTIONS.addCompanyInfo({
				id: event.target.id,
				data: event.target.checked ? 5 : 0,
				stateObject: 'match_score_weights',
			})
		);
		//console.log(matchScoreWeights, 'matchScoreWeights');
	};

	const onSearch = (searchTerm) => {
		setSearchValue(searchTerm);
	};

	return (
		<div className='stepContainer'>
			<div className='SFInput'>
				{loading ? (
					<LoadingIndicator />
				) : (
					<>
						<p className='SFSubTitle'>
							<div>{i18n.t('searchflow.preferencesheader')}</div>{' '}
							<span className='questionTracker'>2/2</span>
						</p>
						<CheckboxInput
							handleCheck={handleChange}
							dataText={preferencesText()}
							stateObject={'match_score_weights'}
						/>
						{matchScoreWeights.distanceWeight === 5 && (
							<>
								<p className='SFSubTitle' style={{ marginTop: '20px' }}>
									{i18n.t('searchflow.sfservicestext4')}
								</p>
								<div
									//className='SFRadioInput'
									onWheel={(e) => {
										e.target.blur();
									}}>
									<TextField
										onChange={(e) => setSearchValue(e.target.value)}
										error={error}
										value={searchValue}
										style={{ fontFamily: 'Quicksand !important' }}
									/>
									{searchValue && companyStore.city !== searchValue && (
										<div className='SFCityList'>
											{cities
												.filter((item) =>
													item.city
														.toLowerCase()
														.includes(searchValue.toLowerCase())
												)
												.map(
													(item, idx) =>
														searchValue !== item.city && (
															<div
																style={{ padding: '2px' }}
																key={idx + item.zip}
																onClick={() => {
																	onSearch(item.city);
																	dispatch(
																		ACTIONS.addCompanyInfo({
																			id: 'zip_code',
																			data: item.zip,
																			stateObject: 'company_store',
																		})
																	);
																	dispatch(
																		ACTIONS.addCompanyInfo({
																			id: 'city',
																			data: item.city,
																			stateObject: 'company_store',
																		})
																	);
																}}>
																{item.city}
															</div>
														)
												)}
										</div>
									)}
								</div>
								{error ? (
									<span
										style={{
											color: 'red',
											fontSize: '12px',
											fontWeight: 'bold',
										}}>
										{i18n.t('searchflow.sfservicestext5')}
									</span>
								) : null}
							</>
						)}
					</>
				)}
			</div>
			<Navigation
				step={12}
				handleBack={() => handleBack()}
				handleNext={async () => {
					handleNext();
				}}
				openHelpForm={() => props.openHelpForm()}
			/>
		</div>
	);
};

export default withTranslation()(Preferences);
